// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import MobileInsurance from './Zong/mobileinsurance';
import MobileOTP from './Zong/MobileOTP';
import Success from './Zong/success';
const App = () => {
    return (
        <Router>
            <Routes>
               
                <Route path="/" element={<MobileInsurance />} />
                <Route path="/mobile-otp" element={<MobileOTP />} />
                <Route path="/success" element={<Success />} />
                {/* Add more routes as needed */}

                {/* Catch-all route for 404 page */}
                <Route path="*" element={<h1>404 Not Found</h1>} />
            </Routes>
        </Router>
    );
};

export default App;
